export default "__VITE_ASSET__CNU44ztC__"